var NODE_ENV = process.env.NODE_ENV;
console.log(NODE_ENV);
module.exports = {
	'title': 'Specialt',
	'store_version': 72,
	/* Development & Staging */
	// 'apiUrl': NODE_ENV === 'development' ? 'http://localhost:3031' : 'http://localhost:3031',
	/* Staging */
	'apiUrl': NODE_ENV === 'development' ? 'https://special-t--api-staging.herokuapp.com/' : 'https://special-t--api-staging.herokuapp.com/',
	/* Live */
	// 'apiUrl': NODE_ENV === 'development' ? 'https://special-t-api.herokuapp.com' :'https://special-t-api.herokuapp.com',
	/* STAGING */
	'firebase': {
		apiKey: "AIzaSyDyNiThTDiyGqtAEH6E7kLVtq6FHgEvkTM",
		authDomain: "specialtdev-962e0.firebaseapp.com",
		databaseURL: "https://specialtdev-962e0.firebaseio.com",
		projectId: "specialtdev-962e0",
		storageBucket: "specialtdev-962e0.appspot.com",
		messagingSenderId: "491425280373"
	},
	/* Live */
	// 'firebase': {
	// 	apiKey: "AIzaSyAtWd3mG9SleZ2twlXiBcCx076azkoaloM",
	// 	authDomain: "specialt-a289f.firebaseapp.com",
	// 	databaseURL: "https://specialt-a289f.firebaseio.com",
	// 	projectId: "specialt-a289f",
	// 	storageBucket: "specialt-a289f.appspot.com",
	// 	messagingSenderId: "491425280373"
	// },
	'setGuardians': false
}


//////////////////
// WEBPACK FOOTER
// ./config/app.js
// module id = 114
// module chunks = 0